<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';

/**
 * Dashboard Component
 */
export default {
    page: {
    title: "Utilisateurs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Utilisateurs",
      items: [
        {
          text: "Menu",
          href: "/",
        },
        {
          text: "Utilisateurs",
          active: true,
        },
        {
          text: "Un utilisateur",
          active: true,
        },
      ],
      user: {},
      transfers: [],
      id: "",
    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date) 
    },
    getItem() {
      fetch(Helper.route('users/'+this.id+"/details"), Helper.requestOptions())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {

        console.log(data);
      
        
        this.user = data
      })
    },
    getTransactions() {
      fetch(Helper.route('transfers/of/users/'+this.id), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        console.log("transfers : ",data);
        this.transfers = data
      })
    },
  },
  mounted() {
    this.id = this.$route.params.id
    this.getItem()
    this.getTransactions()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    
    <div class="row" v-if="user.id">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">À propos de l'utilisateur</h4>
            <div class="row">
              <div class="col-lg-3 mx-auto">
                <img :src="user?.profile" :alt="user.lastName" style="height: 120px; width: 120px" class="border rounded-circle">
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Nom de Famille</dt>
                  <dd>{{ user.lastName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Prénom(s)</dt>
                  <dd>{{ user.firstName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sexe</dt>
                  <dd>{{ user.gender == true ? "Masculin" : "Féminin" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Email</dt>
                  <dd>{{ user.email }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Code</dt>
                  <dd>{{ user.code }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Pays</dt>
                  <dd>{{ user?.country?.name_fr ?? "Non definie"}}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Ville</dt>
                  <dd>{{ user.city ?? "Non definie" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Statut</dt>
                  <dd>
                    <button class="badge badge-pill badge-soft-success border-0 py-1 px-3" v-if="user.status == 'active'">ACTIF</button>
                    <button class="badge badge-pill badge-soft-danger border-0 py-1 px-3" v-else>{{ user.status }}</button>
                  </dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Role</dt>
                  <dd>{{ user.roles[0] }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Date d'inscription</dt>
                  <dd>{{ toDate(user.createdAt) }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>IP</dt>
                  <dd>{{ user.ip }}</dd>
                </dl>
              </div>


              <div class="col-md-3">
                <dl class="user-dev-info">
                  <dt>Devise</dt>
                  <dd>{{ user.devise }}</dd>
                </dl>
              </div>


            </div>

             
            

            <div class="row bg-white border py-4">
              <div class="col-lg-12">
                <div class="">
                  <div class="">
                    <h4 class="card-title">Listes des transactions</h4>
                    <p class="card-title-desc">
                      Le tableau ci-dessous présente la listes des <code>transactions</code>.
                    </p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0">
                        <thead class="bg-light rounded">
                          <tr>
                            <th>#</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Amount</th>
                            <th>Rate</th>
                            <th>Receive</th>
                            <th>Date</th>
                            <th>Statut</th>
                            <th>Voir Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(transfer, i) in transfers" :key="transfer.id">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>{{ transfer.fromAccount }}</td>
                            <td>{{ transfer.toAccount }}</td>
                            <td>{{ transfer.sentAmount }}</td>
                            <td>{{ transfer.rate }}</td>
                            <td>{{ transfer.receivedAmount }}</td>
                            <td>{{ toDate(transfer.createdAt) }}</td>
                            <td>
                              <span v-if="transfer.status == 'error'" class="badge badge-pill badge-soft-danger font-size-11">
                                  {{ transfer.status }}
                              </span>
                              <span v-if="transfer.status !== 'error'" class="badge badge-pill badge-soft-success font-size-11">
                                  {{ transfer.status }}
                              </span>
                            </td>
                            <td>
                              <router-link class="rounded-pill btn-sm btn-primary px-3" :to="'/transfers/'+transfer.id">Voir detail</router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>



